// GetHeader returns all the data necessary to render the header of the brand hub page, i.e. everything until the category and filter selection.
export const BrandHubPageService_GetHeaderLazy = () =>
  import("./service.grpc").then((m) => m.BrandHubPageService_GetHeader);
BrandHubPageService_GetHeaderLazy.method =
  "aysa_api.services.brand_hub.v1.BrandHubPageService/GetHeader" as const;

// GetCategories returns a level of categories for the selected brand and optionally the selected category.
export const BrandHubPageService_GetCategoriesLazy = () =>
  import("./service.grpc").then((m) => m.BrandHubPageService_GetCategories);
BrandHubPageService_GetCategoriesLazy.method =
  "aysa_api.services.brand_hub.v1.BrandHubPageService/GetCategories" as const;

// GetFilter returns filters for the products of the selected brand and category.
export const BrandHubPageService_GetFilterLazy = () =>
  import("./service.grpc").then((m) => m.BrandHubPageService_GetFilter);
BrandHubPageService_GetFilterLazy.method =
  "aysa_api.services.brand_hub.v1.BrandHubPageService/GetFilter" as const;

// GetRecommendedBrands should be called after a user follows/likes a brand.
// This resource will return a list of recommended brands for the user.
export const BrandHubPageService_GetRecommendedBrandsLazy = () =>
  import("./service.grpc").then(
    (m) => m.BrandHubPageService_GetRecommendedBrands
  );
BrandHubPageService_GetRecommendedBrandsLazy.method =
  "aysa_api.services.brand_hub.v1.BrandHubPageService/GetRecommendedBrands" as const;

// GetShopStream returns a slice of the brand hub shop stream.
// Subsequent items can requested with the given [next_state] via GetShopStreamNext.
// NOTE:
// 1. The AppliedFilters might be altered when [GetShopStreamRequest.is_size_finder_enabled].
// Its expected that clients will use the [GetShopStreamResponse.applied_filters] for subsequent requests
export const BrandHubPageService_GetShopStreamLazy = () =>
  import("./service.grpc").then((m) => m.BrandHubPageService_GetShopStream);
BrandHubPageService_GetShopStreamLazy.method =
  "aysa_api.services.brand_hub.v1.BrandHubPageService/GetShopStream" as const;

// GetShopStreamNext returns the next slice of the brand hub shop stream
export const BrandHubPageService_GetShopStreamNextLazy = () =>
  import("./service.grpc").then((m) => m.BrandHubPageService_GetShopStreamNext);
BrandHubPageService_GetShopStreamNextLazy.method =
  "aysa_api.services.brand_hub.v1.BrandHubPageService/GetShopStreamNext" as const;

// GetDiscoverStream returns the brand hub discover stream
export const BrandHubPageService_GetDiscoverStreamLazy = () =>
  import("./service.grpc").then((m) => m.BrandHubPageService_GetDiscoverStream);
BrandHubPageService_GetDiscoverStreamLazy.method =
  "aysa_api.services.brand_hub.v1.BrandHubPageService/GetDiscoverStream" as const;

// GetHeaderV2 returns all the data necessary to render the header of the brand hub page, i.e. everything until the category and filter selection.
export const BrandHubPageService_GetHeaderV2Lazy = () =>
  import("./service.grpc").then((m) => m.BrandHubPageService_GetHeaderV2);
BrandHubPageService_GetHeaderV2Lazy.method =
  "aysa_api.services.brand_hub.v1.BrandHubPageService/GetHeaderV2" as const;

// GetStream   returns a slice of the brand hub shop stream.
// Subsequent items can requested with the given [next_state] via GetShopStreamNext.
// NOTE:
// 1. The AppliedFilters might be altered when [GetShopStreamRequest.is_size_finder_enabled].
// Its expected that clients will use the [GetShopStreamResponse.applied_filters] for subsequent requests
export const BrandHubPageService_GetStreamLazy = () =>
  import("./service.grpc").then((m) => m.BrandHubPageService_GetStream);
BrandHubPageService_GetStreamLazy.method =
  "aysa_api.services.brand_hub.v1.BrandHubPageService/GetStream" as const;

// GetStreamNext returns the next slice of the brand hub shop stream
export const BrandHubPageService_GetStreamNextLazy = () =>
  import("./service.grpc").then((m) => m.BrandHubPageService_GetStreamNext);
BrandHubPageService_GetStreamNextLazy.method =
  "aysa_api.services.brand_hub.v1.BrandHubPageService/GetStreamNext" as const;

// GetTreeNavigation returns the brand hub category tree navigation
export const BrandHubPageService_GetTreeNavigationLazy = () =>
  import("./service.grpc").then((m) => m.BrandHubPageService_GetTreeNavigation);
BrandHubPageService_GetTreeNavigationLazy.method =
  "aysa_api.services.brand_hub.v1.BrandHubPageService/GetTreeNavigation" as const;

// GetNavigation returns the navigation section: categories label and popular filters (for App and mWeb)
export const BrandHubPageService_GetNavigationLazy = () =>
  import("./service.grpc").then((m) => m.BrandHubPageService_GetNavigation);
BrandHubPageService_GetNavigationLazy.method =
  "aysa_api.services.brand_hub.v1.BrandHubPageService/GetNavigation" as const;

// GetNavigationSectionCategories returns the full category tree for the selected brand
export const BrandHubPageService_GetNavigationSectionCategoriesLazy = () =>
  import("./service.grpc").then(
    (m) => m.BrandHubPageService_GetNavigationSectionCategories
  );
BrandHubPageService_GetNavigationSectionCategoriesLazy.method =
  "aysa_api.services.brand_hub.v1.BrandHubPageService/GetNavigationSectionCategories" as const;
